import styled, {css} from "styled-components";

export const StyledOrderDetails = styled.div`
    width: 100%;
    color: var(--text-color);

    .overlay {
        ${({$isOpen}) =>
            $isOpen &&
            css`
                &::before {
                    content: "";
                    position: fixed;
                    inset: 0;
                    z-index: 10;
                    background-color: rgba(0, 0, 0, 0.25);
                }
            `}
    }

    .sidebar {
        width: 100%;
        max-width: 320px;
        background-color: var(--white);
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 10;
        overflow-y: auto;
        transition: all 0.3s ease-in-out;
        border-radius: 20px 0 0 20px;
        padding: 20px;
        @media (min-width: 1024px) {
            max-width: 483px;
        }

        ${({$isOpen}) =>
            $isOpen
                ? css`
                      transform: translateX(0%);
                  `
                : css`
                      transform: translateX(200%);
                  `};

        @media (min-width: 576px) and (max-width: 1023px) {
            max-width: 550px;
            right: 50%;
            top: 50%;
            bottom: auto;
            border-radius: 20px;
            height: 90vh;
            ${({$isOpen}) =>
                $isOpen
                    ? css`
                          transform: translate(50%, -50%);
                      `
                    : css`
                          transform: translate(50%, 150vh);
                      `};
        }

        .closer {
            background: ${({theme}) => theme?.light?.primary};
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 0;
            margin-left: auto;
            margin-bottom: 10px;
        }
        .card-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            margin-bottom: 40px;
            .count-wrap {
                .count {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    color: var(--text-color);
                    font-size: 20px;
                    line-height: 24px;
                    font-weight: 500;
                    margin-bottom: 5px;
                    @media (min-width: 576px) {
                        font-size: 24px;
                        line-height: 26px;
                    }
                    .dot {
                        display: block;
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background-color: rgba(44, 185, 255, 1);
                    }
                }
            }
            .status {
                padding: 7px 10px;
                border-radius: 30px;
                font-size: 13px;
                line-height: 17px;
                font-weight: 400;
                &.pending {
                    color: rgba(245, 126, 42, 1);
                    background: rgba(245, 126, 42, 0.2);
                }
                &.preparing {
                    color: rgba(44, 185, 255, 1);
                    background: rgba(44, 185, 255, 0.2);
                }
                &.ready {
                    color: rgba(39, 196, 83, 1);
                    background: rgba(39, 196, 83, 0.2);
                }
                &.completed {
                    color: rgba(119, 119, 119, 1);
                    background: rgba(119, 119, 119, 0.2);
                }
                &.delivery {
                    color: rgba(94, 64, 153, 1);
                    background: rgba(94, 64, 153, 0.2);
                }
            }

            .time {
                color: rgba(143, 143, 143, 1);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
                @media (min-width: 576px) {
                    font-size: 18px;
                    line-height: 22px;
                }
            }
        }
        .items-list {
            list-style: none;
            margin-bottom: 30px;
            li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 16px;
                margin-bottom: 20px;
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
                color: var(--text-color);
                @media (min-width: 576px) {
                    font-size: 20px;
                    line-height: 24px;
                }
                .item-price {
                    color: var(--text-color);
                    font-weight: 400;
                }
            }
        }
        .special-instructions {
            padding: 15px;
            background: rgba(245, 126, 42, 0.1);
            border-radius: 10px;
            margin-bottom: 15px;
            .title {
                color: var(--primary);
                display: block;
                font-size: 20px;
                line-height: 24px;
                font-weight: 400;
                margin-bottom: 10px;
            }
            .desc {
                color: var(--primary);
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
            }
        }
        .separator {
            width: 100%;
            border-bottom: 1px solid rgba(233, 233, 233, 1);
            margin-bottom: 15px;
        }
        .details-wrap {
            .details-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 30px;
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                color: var(--text-color);

                strong {
                    font-weight: 500;
                }
            }

            .details-list {
                list-style: none;
                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 13px;
                    margin-bottom: 15px;
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 300;
                    color: var(--text-color);

                    strong {
                        font-weight: 400;
                    }

                    &.name {
                        font-size: 18px;
                        line-height: 22px;
                        font-weight: 400;
                    }
                }
            }
        }

        .delivery-wrap {
            margin-bottom: 30px;
            .delivery-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 15px;
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                color: var(--text-color);

                strong {
                    font-weight: 500;
                }
            }
            .location {
                color: rgba(143, 143, 143, 1);
                font-size: 14px;
                line-height: 18px;
                font-weight: 300;
                margin-bottom: 20px;
            }

            .rider-wrap {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 10px;
                padding: 15px;
                border-radius: 10px;
                background: rgba(44, 185, 255, 0.1);
                .rider-name {
                    color: var(--text-color);
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: 500;
                    margin-bottom: 10px;
                    @media (min-width: 576px) {
                        font-size: 20px;
                        line-height: 24px;
                    }
                }
                .rider-time {
                    color: var(--text-color);
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 300;
                    @media (min-width: 576px) {
                        font-size: 16px;
                        line-height: 20px;
                    }
                }
                .btn {
                    width: 107px;
                    cursor: pointer;
                    padding: 10px;
                    border-radius: 60px;
                    background-color: var(--white);
                    border: none;
                    outline: none;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                }
            }
        }

        .qr-code-wrap {
            width: 100%;
            padding: 15px;
            border: 1px solid rgba(245, 126, 42, 0.15);
            border-radius: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;

            .qr-title {
                color: rgba(49, 49, 49, 1);
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                margin-bottom: 15px;
            }
            .qr-desc {
                display: block;
                color: rgba(143, 143, 143, 1);
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
                margin-bottom: 10px;
            }
            .code-wrap {
                display: flex;
                align-items: center;
                gap: 15px;
                .code {
                    border: 1px solid rgba(245, 126, 42, 0.15);
                    padding: 13px 15px;
                    color: var(--primary);
                    font-size: 20px;
                    line-height: 24px;
                    font-weight: 400;
                    border-radius: 10px;
                }
                img {
                    cursor: pointer;
                }
            }
            .qr-code {
                border-radius: 10px;
                padding: 15px;
                background: rgba(236, 236, 236, 1);
            }
        }

        .payment-wrap {
            .payment-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 30px;
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                color: var(--text-color);

                strong {
                    font-weight: 500;
                }
            }
            .pricing-list {
                list-style: none;
                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 10px;
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 300;
                    color: var(--text-color);
                    .price {
                        font-weight: 400;
                    }
                    &.total {
                        font-size: 18px;
                        line-height: 22px;
                        font-weight: 400;
                    }
                }
            }
        }

        .order-wrap {
            .order-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 30px;
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                color: var(--text-color);

                strong {
                    font-weight: 500;
                }
            }
            .order-placed {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 16px;
                margin-bottom: 36px;
                span {
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 300;
                }
            }
        }

        .btn-holder {
            display: flex;
            justify-content: center;
            .print-btn {
                width: 100%;
                max-width: 319px;
                gap: 12px;
            }
        }
    }
`;
